import { Box, Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import type { TranscriptSegment as TranscriptSegmentType } from './types';

type Props = {
  segment: TranscriptSegmentType;
  selected: boolean;
  onClick: () => void;
};

export const TranscriptSegment = ({ segment, selected, onClick }: Props) => {
  return (
    <Box
      bg={selected ? 'brand.1' : undefined}
      style={{
        borderRadius: '12px',
        padding: '12px',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <Flex gap="xxs">
        <Text size="sm" fw={FONT_WEIGHTS.regular} c="gray.7">
          {segment.speaker}
        </Text>
        <Text size="sm" fw={FONT_WEIGHTS.regular} c="gray.7">
          {segment.startTime}
        </Text>
      </Flex>
      <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.10" mt="6px">
        {segment.content}
      </Text>
    </Box>
  );
};
